import React, { useState, useEffect, createContext } from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { buttonStyle } from "./colors";
import IconButton from "@mui/material/IconButton";
import { IoIosAddCircleOutline } from "react-icons/io";
import { Grid, Snackbar } from "@mui/material";

import Outfit1 from "./outfits/outfit 1.png";
import Outfit21 from "./outfits/outfit 21.png";
import Outfit8 from "./outfits/outfit 8.png";
import Outfit14 from "./outfits/outfit 14.png";

import Top1 from "./outfits/top 1.png";
import Top3 from "./outfits/top 3.png";
import Top6 from "./outfits/top 6.png";
import Bottom1 from "./outfits/bottom 1.png";

const OUTFITS = [
  { id: 0, imageId: Top1, type: "top", new: false, alt: "A white tank top" },
  { id: 1, imageId: Top3, type: "top", new: false, alt: "A red collared vest" },
  {
    id: 2,
    imageId: Top6,
    type: "top",
    new: false,
    alt: "A white frilly tank top with one sleeve off the shoulder",
  },
  {
    id: 3,
    imageId: Bottom1,
    type: "bottom",
    new: false,
    alt: "Gray cargo pants",
  },
];
var OUTFITS_LOG = OUTFITS;

function MyCloset() {
  const navigate = useNavigate();

  const { state } = useLocation();

  const [outfits, setOutfits] = useState(OUTFITS_LOG);
  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    // Update the document title using the browser API
    if (state) {
      if (state.newClothes.length > 0) {
        setOpen(true);
      }
      var array = OUTFITS_LOG.map((item) => {
        item.new = false;
        return item;
      });
      OUTFITS_LOG = [...array, ...state.newClothes];
      setOutfits(OUTFITS_LOG);
    }
  }, []);

  return (
    <NavBarLayout
      title="My Closet"
      onBackButtonClicked={() => navigate("/home")}
      active={1}
    >
      <div className="MyCloset-container">
        <Snackbar
          sx={{ maxWidth: "50%", top: "10%", left: "50%" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          message="New Clothes Added!"
          textAlign="right"
        />
        <div className="MyCloset-smallTextContainer">
          <Button sx={{ fontSize: 14, ...buttonStyle }} variant="contained">
            Categories
          </Button>
          <IconButton>
            <IoIosAddCircleOutline color="#e17667" size="2.5rem" />
          </IconButton>
        </div>
        <div className="MyCloset-sections-container">
          <div className="MyCloset-outfitContainer">
            <img
              style={{ height: "15vh", width: "90%" }}
              src={Outfit14}
              alt=""
            ></img>
            <span className="MyCloset-caption">Work</span>
          </div>
          <div className="MyCloset-outfitContainer">
            <img
              style={{ height: "15vh", width: "120%" }}
              src={Outfit8}
              alt=""
            ></img>
            <span className="MyCloset-caption">Formal</span>
          </div>
        </div>

        <div className="MyCloset-smallTextContainer">
          <Button sx={{ fontSize: 14, ...buttonStyle }} variant="contained">
            Outfits
          </Button>
          <IconButton>
            <IoIosAddCircleOutline color="#e17667" size="2.5rem" />
          </IconButton>
        </div>
        <div className="MyCloset-sections-container">
          <div className="MyCloset-outfitContainer">
            <img
              style={{ height: "15vh" }}
              src={Outfit1}
              alt="A classy office fit, with a beige suit jacket layered over a white button down and a brown skirt"
            ></img>
            <span className="MyCloset-caption">Classy Office Fit</span>
          </div>
          <div className="MyCloset-outfitContainer">
            <img
              style={{ height: "15vh", width: "110%" }}
              src={Outfit21}
              alt="A chic office outfit, with a cream colored short sleeve top and gray slacks"
            ></img>
            <span className="MyCloset-caption">Chic Office Fit</span>
          </div>
        </div>

        <div className="MyCloset-smallTextContainer">
          <Button sx={{ fontSize: 14, ...buttonStyle }} variant="contained">
            Clothes
          </Button>
          <IconButton
            onClick={() => {
              navigate("/addmethods");
            }}
          >
            <IoIosAddCircleOutline color="#e17667" size="2.5rem" />
          </IconButton>
        </div>
        <div className="MyCloset-clothes-container">
          <span className="MyCloset-caption">Tops </span>
          <Grid container spacing={1} rowSpacing={0.01}>
            {outfits
              .filter((outfit) => outfit.type === "top")
              .map((outfit) => (
                <Grid item xs={4}>
                  <div
                    className={`MyCloset-outfitContainer${
                      outfit.new ? "New" : ""
                    }`}
                  >
                    <img
                      style={{ height: "15vh", width: "120%" }}
                      src={outfit.imageId}
                      alt={outfit.alt}
                    ></img>
                  </div>
                </Grid>
              ))}
          </Grid>
          <span className="MyCloset-caption">Bottoms </span>
          <Grid container spacing={2} rowSpacing={0.01}>
            {outfits
              .filter((outfit) => outfit.type === "bottom")
              .map((outfit) => (
                <Grid item xs={4}>
                  <div
                    className={`MyCloset-outfitContainer${
                      outfit.new ? "New" : ""
                    }`}
                  >
                    <img
                      style={{ height: "15vh", width: "120%" }}
                      src={outfit.imageId}
                      alt={outfit.alt}
                    ></img>
                  </div>
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default MyCloset;
